(function(){
    'use strict'

    angular.module('app.horarios')
    .factory('HorariosService', HorariosService);

    HorariosService.$inject = ['$http', '$q', 'apiSettings'];

    function HorariosService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/horarios';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(horarioId){

            var url = apiSettings.apiBaseUrl + 'api/horarios/' + horarioId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(horario){

            horario.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/horarios',  
                method: 'POST',  
                data: horario
            });  
            return response;
        };

        function update(horario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/horarios',  
                method: 'PUT',  
                data: horario
            });  
            return response;
        };

        function remove(horario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/horarios',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: horario
            });  
            return response;
        };

    };

})();